import React from "react";
import { Box } from "@mui/material";
import Heading from "../../components/Heading";
import TeamSlider from "../../components/TeamSlider";
import { getMeaning } from "../../utils/localization";
import ProfileCard from "../../components/ProfileCard";
import { TailoredStyles } from "../../components/Styles";
import DetailsCard from "../../components/About/DetailsCard";
import GlobalSubHeading from "../../components/GlobalSubHeading";
import EmpoweredQuote from "../../components/About/EmpoweredQuote";

const AboutUs = () => {
  return (
    <Box sx={[TailoredStyles.mainbannerBox1, { marginTop: 10 }]}>
      <Box sx={{ mx: { xs: 4, sm: 4 } }}>
        <DetailsCard />
      </Box>

      <Box sx={{ mt: { xs: -10, md: -4, lg: -6 } }}>
        <EmpoweredQuote />
      </Box>

      <Box mb={3} sx={{ textAlign: "center", mx: { xs: 2.2, sm: 2.2 } }}>
        <Heading title={getMeaning("ABTS.MEETLEADR")} />
        {/* <Typography sx={[HomeBannerStyles.bannerTitle]}>
          {getMeaning("ABTS.MEETLEADR")}
        </Typography> */}

        <Box align="center">
          <GlobalSubHeading subTitle={getMeaning("ABTS.LEADRSBHDNG")} />
          {/* <Typography
            sx={[
              HomeBannerStyles.bannerDescription,
              { width: { xs: "95%", sm: "95%", md: "80%" } },
            ]}
          >
            {getMeaning("ABTS.LEADRSBHDNG")}
          </Typography> */}
        </Box>
      </Box>

      <ProfileCard />

      <TeamSlider />

      {/* <OurTeamsSwiper teamMembers={TEAM_MEMBER_DETAILS} /> */}

      {/* <Grid
        mb={4}
        mt={2}
        container
        direction="column"
        spacing={4}
        justifyContent="center"
        alignItems="center"
        sx={ScrollCardStyles.scrollContainer}
      >
        <Grid item>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={6} md={3}>
              <FlipCard {...TEAMMEMBER[0]} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container spacing={2} justifyContent="center">
            {TEAMMEMBER.slice(1, 3).map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <FlipCard {...item} />
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item>
          <Grid container spacing={2} justifyContent="center">
            {TEAMMEMBER.slice(3, 6).map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index + 3}>
                <FlipCard {...item} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid> */}
    </Box>
  );
};

export default AboutUs;
